
  import { defineComponent, ref } from 'vue';
  import { Modal, modalProps, ModalProps } from '@/ui/components/Modal';
  import { Loader } from '@/ui/components/Loader';
  import { CREATE_TEMPLATE_REPORT_MODAL_WIDTH } from './constants';
  import { Button } from '@/ui/components/Button';
  import { DropdownField } from '@/ui/components/form/DropdownField';
  import { PageSubtitle } from '@/ui/components/PageSubtitle';
  import { useReportTemplate } from '@/ui/concerns/analytics/useReportTemplate';

  export default defineComponent<ModalProps>({
    components: {
      Modal,
      Loader,
      Button,
      PageSubtitle,
      DropdownField,
    },
    props: modalProps,
    setup(_, { emit }) {
      const { getFormTemplatesTask, templates } = useReportTemplate();
      const templateId = ref(0);

      const closeModal = () => {
        emit('close');
      };

      const onCreateReport = () => {
        emit(
          'create-report-template',
          templateId.value,
          templates.value.find(t => t.value === templateId.value)?.label,
        );
      };

      return {
        templateId,
        templates,
        closeModal,
        getFormTemplatesTask,
        onCreateReport,
        CREATE_TEMPLATE_REPORT_MODAL_WIDTH,
      };
    },
  });
